module.exports = __webpack_public_path__ + "static/media/buttona.82ee5817.svg";